// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DVUD","badges":"styles_badges__2FFja"};